<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Categories</h2>
          </header>
        </div>
      </div>
      <div class="inputCard">
        <header>Product Categories</header>
        <div class="content">
          <div class="input-row-button w3-padding-8 w3-border-bottom">
            <input v-model="newCategory.title" placeholder="Category Name" class="w3-input w3-border" style="border-radius:5px;" />
            <v-select placeholder="Parent" @input="setParent($event)" label="title" :options="state.siteData.content.products.categories"></v-select>
            <div class="w3-right-align">
              <button class="w3-button w3-small w3-green" @click="addCategory()">Add</button>
            </div>
          </div>
          <div class="categoriesGrid w3-padding-8 w3-border-bottom">
            <div class="w3-center"><b>ID</b></div>
            <div class="categoryName"><b>Name</b></div>
            <div class="categoryURL"><b>URL</b></div>
            <div class="categoryParent"><b>Parent</b></div>
            <div class="w3-right-align"><b>Actions</b></div>
          </div>
          <div class="categoriesGrid w3-padding-8" v-for="(category, index) in state.siteData.content.products.categories" :key="index">
            <div class="w3-center">{{category.id}}</div>
            <div class="categoryName">{{category.title}}</div>
            <div class="categoryURL" @click="editSlug(category)">
              <template v-if="editingSlug !== category.id">{{category.slug}}</template>
              <template v-else>
                <div style="width:220px; display:inline-block;">
                  <input class="w3-input w3-border" v-model="category.slug" :ref="'categoryInput' + category.id" />
                </div>
                <button class="w3-button w3-small w3-green w3-right" style="padding:4px 8px;" @click.stop="saveCategory(category)"><i class="fa fa-check"></i></button>
              </template>
            </div>
            <div class="categoryParent">{{categoryName(category.parentid)}}</div>
            <div class="buttons">
              <div class="buttons row2" style="grid-gap:2px;">
                <router-link tag="button" :to="'/cms/categories-detail/' + category.id" class="w3-button w3-small w3-teal w3-block">Edit</router-link>
                <button class="w3-button w3-small w3-red w3-block" @click="deleteCategory(category.id)">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsproductcategories',
  data() {
    return {
      state: dataStore.state,
      newCategory: {
        id: 0,
        title: '',
        image: '',
        parentid: 0,
        slug: ''
      },
      activePage: 1,
      editingSlug: 0
    }
  },
  methods: {
    gotoPage(page) {
      if (page === '-1') {
        if (this.activePage > 1) {
          this.activePage--
        }
      } else if (page === '+1') {
        if (this.activePage < Math.ceil(this.state.siteData.content.products.items.length / 9)) {
          this.activePage++
        }
      } else {
        this.activePage = page
      }
    },
    setParent(parent) {
      this.newCategory.parentid = parent.id
    },
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deleteCategory(id) {
      let itemIndex = this.state.siteData.content.products.categories.findIndex(savedCategory => savedCategory.id === id)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.content.products.categories[itemIndex].title + ' category?')) {
          this.state.siteData.content.products.categories.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    },
    addCategory() {
      this.newCategory.id = Math.max(...this.state.siteData.content.products.categories.map(o => o.id), 0) + 1
      this.newCategory.slug = slug(this.newCategory.title)
      this.state.siteData.content.products.categories.push(this.newCategory)
      this.newCategory = {
        id: 0,
        title: '',
        image: '',
        parentid: this.newCategory.parentid,
        slug: ''
      }
    },
    categoryName(id) {
      let itemIndex = this.state.siteData.content.products.categories.findIndex(savedCategory => savedCategory.id === id)
      if (itemIndex > -1) {
        return this.state.siteData.content.products.categories[itemIndex].title
      } else {
        return 'None'
      }
    }
  }
}
</script>

<style scoped>
  .cmsProductsPageGrid {display:grid; grid-template-columns: 1fr 2fr; grid-gap: 8px;}
  .categoriesGrid {display:grid; grid-template-columns: 30px 1fr 250px 120px 100px; grid-gap:8px; border-bottom: 1px solid #ccc; font-family: 'Roboto';}
  .categoriesGrid:last-child {border-bottom:0;}
  .categoriesGrid div {align-self: center;}
  .categoriesGrid .buttons button {padding:4px;}
  .categoryName {padding-left:8px;}
  .input-row-button {display:grid; grid-template-columns: 1fr 1fr 60px; grid-gap: 8px;}

  .productsContentGrid {display:grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); grid-gap: 8px;}
  .cardImage {height:150px; width:100%; overflow:hidden; background-position: center; background-size: cover;}

  .headerRightGrid {display: grid; grid-template-columns: 1fr 115px; grid-gap:8px;}

  .buttons {text-align: right;}
  .inputCard header {text-align: left; padding-left:12px;}
@media screen and (max-width:993px) {
  .productsTitle {font-size:10pt;}
  .productsMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsProductCategories.vue